<template lang="pug">
  vm-table(:data="fabricateds")
    template(slot="header")
      .d-flex.justify-content-between
        div
    template(slot="thead")
      vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
      vm-th
    template(slot-scope="{data}")
      vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
        vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
          //- h3 {{data[indextr]}}
          slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
          slot(v-if="column != 'status' && column != 'total'") {{data[indextr][column]}}
</template>

<script>

export default {
  name: 'FabricatedTab',
  props: {
    fabricateds: {
      type: Array
    }
  },  
  data: () => ({
    columns: [
      'quantity',
      'fabricated_date'
    ]
  })
}
</script>

